import { Button } from "@/components/ui/button";
import { Eye, EyeOff } from "lucide-react";
import { MouseEvent } from "react";

type ToggleVisibilityButtonPropsType = {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  isVisible: boolean;
};
const ToggleVisibilityButton = ({ onClick, isVisible }: ToggleVisibilityButtonPropsType) => {
  return (
    <Button variant="outline" onClick={onClick}>
      {isVisible ? <EyeOff /> : <Eye />}
    </Button>
  );
};
export default ToggleVisibilityButton;
